export const environment = {
  envName: 'test',
  production: true,
  enableSEO: false,
  sentryLogging: true,
  apiUrl: typeof window === 'undefined' ? 'http://klubovna-api-test:3000/api' : 'https://app-test.klubovnasl.sk/api',
  appUrl: 'https://app-test.klubovnasl.sk',
  publicWebUrl: 'https://test.klubovnasl.sk',
  staticContentUrl: 'https://s3.klubovnasl.sk/klubovna-test-public',
};
